import { render, staticRenderFns } from "./CustomRadioGroup.vue?vue&type=template&id=3270ef06&scoped=true&"
import script from "./CustomRadioGroup.vue?vue&type=script&lang=js&"
export * from "./CustomRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3270ef06",
  null
  
)

export default component.exports